define.alias("ember-power-select/components/power-select/power-select-group", "media/components/power-select/power-select-group");